import { createAction, props } from '@ngrx/store';

export const setForestryKml = createAction('[Parcel] Set selected forestry KML', props<{ data: Array<any> }>());

export const clearAll = createAction('[Parcel] Clear All');
